export default __webpack_public_path__ + "static/media/1.bf56d6e9.png";